// extracted by mini-css-extract-plugin
module.exports = {"messageBody":"confirmModal__messageBody__wIh","bounceIn":"confirmModal__bounceIn__3IV","highlightWallMessage":"confirmModal__highlightWallMessage__1KL"};